import { useState } from 'react'
import './nameDialog.css'
import { IPlayer } from '../Services/ServiceSecurity'
import { WooNotesButton, WooNotesButtonColor, WooNotesButtonSize } from '../WooNotes/WooNotesButton'
import { WooNotesErrorAlert } from '../WooNotes/WooNotesErrorAlert'

type Props = {
  player: IPlayer | undefined
  onSave: (player: IPlayer, password: string) => void
  onCancel: () => void
}

export const ChangePasswordDialog = ({ player, onSave, onCancel }: Props) => {
  const [password, setPassword] = useState('')
  const [password2, setPassword2] = useState('')
  const [errorMsg, setErrorMsg] = useState('')

  if (!player) return null

  return (
    <div className="dialog-root">
      <div className="dialog-backdrop" onClick={onCancel} />

      <div className="dialog">
        <h3>Change password for {player.Username}</h3>

        <input
          type="password"
          autoFocus
          value={password}
          onChange={e => {
            setPassword(e.target.value)
            setErrorMsg('')
          }}
          placeholder="Enter password"
        />
        <input
          type="password"
          value={password2}
          onChange={e => {
            setPassword2(e.target.value)
            setErrorMsg('')
          }}
          placeholder="Validate password"
        />
        <div style={{ width: '100%', alignItems: 'center', justifyItems: 'center' }}>
          <div style={{}}>
            <WooNotesErrorAlert title='' message={errorMsg} shadowColor='black' />
          </div>
        </div>

        <div className="actions">
          <WooNotesButton size={WooNotesButtonSize.Slim} color={WooNotesButtonColor.White} onClick={() => onCancel()}>
            Cancel
          </WooNotesButton>
          <WooNotesButton
            size={WooNotesButtonSize.Slim}
            color={WooNotesButtonColor.Blue}
            disabled={!password.trim() && !password2.trim()}
            onClick={() => {
              setErrorMsg('')
              const p1 = password.trim()
              const p2 = password2.trim()

              if (!p1 || p1 !== p2) {
                setErrorMsg('Passwords is not equal')
                return
              }

              onSave(player, password)
            }}
          >
            Save
          </WooNotesButton>
        </div>
      </div>
    </div>
  )
}
